var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComunidad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 104.337,
    height: 104.336,
    viewBox: "0 0 104.337 104.336",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#a4c2f7;}.b{fill:url(#a);}.c{fill:#7fabfa;}.d{fill:#d4e1f4;}.e{fill:#f1eaf4;}.f{fill:#fff;}.g{fill:#264ecc;}.h{fill:#7821a0;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: -2.277,
    y1: -7.726,
    x2: -2.275,
    y2: -7.723,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#dae2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201,
    stopColor: "#ebeaf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201,
    stopColor: "#f6eff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202,
    stopColor: "#fdf2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.205,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.252,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.397,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#dae2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421,
    stopColor: "#ebeaf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421,
    stopColor: "#f6eff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#fdf2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f8f0f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#e7e8f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#dce3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#d5e0f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.706,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851,
    stopColor: "#d3dff2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-185.159 -780.903)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(186.898 782.642)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M287.9,786.261V859.3H187.04V786.261a3.488,3.488,0,0,1,3.478-3.477h93.9A3.487,3.487,0,0,1,287.9,786.261Z",
    transform: "translate(-187.04 -782.784)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M282.682,786.261V859.3H187.04V786.261a3.488,3.488,0,0,1,3.478-3.477H279.2A3.488,3.488,0,0,1,282.682,786.261Z",
    transform: "translate(-187.04 -782.784)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 20.867,
    height: 19.128,
    transform: "translate(39.996 76.513)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 73.035)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M287.9,861.778v3.478a3.487,3.487,0,0,1-3.477,3.477h-93.9a3.488,3.488,0,0,1-3.478-3.477v-3.478Z",
    transform: "translate(-187.04 -861.778)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M265.54,887.875v3.287H213.371v-3.287a5.4,5.4,0,0,1,5.409-5.408h41.352a5.4,5.4,0,0,1,5.408,5.408Z",
    transform: "translate(-189.026 -863.339)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M245.524,865.54v19.128H224.656V881.19h5.217V869.018h-5.217V865.54Z",
    transform: "translate(-189.877 -789.026)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 73.035)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M282.682,861.778v3.478a3.488,3.488,0,0,1-3.478,3.477H190.518a3.488,3.488,0,0,1-3.478-3.477v-3.478Z",
    transform: "translate(-187.04 -861.778)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M260.322,887.875v3.287H213.371v-3.287a5.4,5.4,0,0,1,5.409-5.408h36.135a5.4,5.4,0,0,1,5.408,5.408Z",
    transform: "translate(-189.026 -863.339)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.562 15.65)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M262.451,821.076a20.861,20.861,0,0,1-20.867,20.867v-8.7a12.173,12.173,0,0,0,8.608-20.781l6.156-6.156A20.8,20.8,0,0,1,262.451,821.076Z",
    transform: "translate(-220.716 -800.209)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M239.969,834.767v8.695a20.834,20.834,0,0,1-19.789-14.277l8.243-2.748A12.19,12.19,0,0,0,239.969,834.767Z",
    transform: "translate(-219.102 -801.727)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M239.881,799.711v8.695a12.163,12.163,0,0,0-11.547,16.016l-8.242,2.748a20.221,20.221,0,0,1-1.078-6.59,20.862,20.862,0,0,1,20.867-20.867Z",
    transform: "translate(-219.014 -799.711)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M256.347,805.815l-6.156,6.156a12.131,12.131,0,0,0-8.608-3.565v-8.695A20.8,20.8,0,0,1,256.347,805.815Z",
    transform: "translate(-220.716 -799.711)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.956 6.956)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M269.8,792.046V802.48a1.739,1.739,0,0,0,1.739,1.738h1.738v6.956l8.7-6.956h3.477a1.739,1.739,0,0,0,1.739-1.738V792.046a1.739,1.739,0,0,0-1.739-1.739H271.535A1.739,1.739,0,0,0,269.8,792.046Z",
    transform: "translate(-200.238 -790.307)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M211.952,792.046V802.48a1.739,1.739,0,0,1-1.738,1.738h-1.739v6.956l-8.695-6.956H196.3a1.739,1.739,0,0,1-1.739-1.738V792.046a1.739,1.739,0,0,1,1.739-1.739h13.912A1.739,1.739,0,0,1,211.952,792.046Z",
    transform: "translate(-194.563 -790.307)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M269.8,850.813V840.38a1.739,1.739,0,0,1,1.739-1.739h1.738v-6.956l8.7,6.956h3.477a1.739,1.739,0,0,1,1.739,1.739v10.434a1.738,1.738,0,0,1-1.739,1.738H271.535A1.738,1.738,0,0,1,269.8,850.813Z",
    transform: "translate(-200.238 -793.428)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M211.952,850.813V840.38a1.739,1.739,0,0,0-1.738-1.739h-1.739v-6.956l-8.695,6.956H196.3a1.739,1.739,0,0,0-1.739,1.739v10.434a1.738,1.738,0,0,0,1.739,1.738h13.912A1.737,1.737,0,0,0,211.952,850.813Z",
    transform: "translate(-194.563 -793.428)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 5.217,
    height: 12.173,
    transform: "translate(39.996 79.991)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M192.256,859.3V786.261a3.488,3.488,0,0,1,3.478-3.477h-5.216a3.488,3.488,0,0,0-3.478,3.477V859.3a3.488,3.488,0,0,0,3.478,3.477h5.216A3.488,3.488,0,0,1,192.256,859.3Z",
    transform: "translate(-187.04 -782.784)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M224,882.467H218.78a5.4,5.4,0,0,0-5.408,5.408v3.287h5.216v-3.287A5.4,5.4,0,0,1,224,882.467Z",
    transform: "translate(-189.026 -790.303)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(185.159 780.903)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M188.637,786.545v73.036h-3.478V786.545Z",
    transform: "translate(-185.159 -781.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M186.9,803.189a1.832,1.832,0,0,0,1.234-.5,1.763,1.763,0,0,0,0-2.47l-.261-.208a1.26,1.26,0,0,0-.313-.157,1.1,1.1,0,0,0-.313-.1,2.565,2.565,0,0,0-.347-.034,1.827,1.827,0,0,0-1.235.5,1.715,1.715,0,0,0,.573,2.835A1.741,1.741,0,0,0,186.9,803.189Z",
    transform: "translate(-185.16 -782.322)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M284.279,780.9h-93.9a5.222,5.222,0,0,0-5.217,5.216v6.956a1.739,1.739,0,1,0,3.478,0v-6.956a1.739,1.739,0,0,1,1.738-1.738h93.9a1.74,1.74,0,0,1,1.738,1.738v67.819h-97.38V806.987a1.739,1.739,0,0,0-3.478,0v52.169a5.222,5.222,0,0,0,5.217,5.216h34.779v8.695h-8.512a7.147,7.147,0,0,0-7.139,7.139V883.5a1.738,1.738,0,0,0,1.739,1.739h52.168a1.739,1.739,0,0,0,1.739-1.739v-3.294a7.147,7.147,0,0,0-7.139-7.139H249.5v-8.695h34.779a5.222,5.222,0,0,0,5.216-5.216V786.119A5.221,5.221,0,0,0,284.279,780.9Zm-22.607,99.3v1.555H212.982v-1.555a3.665,3.665,0,0,1,3.661-3.661h41.368A3.665,3.665,0,0,1,261.673,880.206Zm-15.65-7.139H228.633v-8.695h17.389Zm38.257-12.173h-93.9a1.74,1.74,0,0,1-1.739-1.738v-1.739h97.381v1.739A1.74,1.74,0,0,1,284.279,860.894Z",
    transform: "translate(-185.159 -780.903)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M218.323,827.619a22.594,22.594,0,1,0,37.493-23.053c-.033-.039-.046-.088-.083-.125a1.44,1.44,0,0,0-.125-.082,22.578,22.578,0,0,0-37.311,23.19l0,.027C218.306,827.591,218.317,827.6,218.323,827.619Zm3.9.481,4.983-1.661A13.929,13.929,0,0,0,238,834.226v5.25A19.16,19.16,0,0,1,222.225,828.1Zm26.03-18.64a13.825,13.825,0,0,0-6.777-2.815v-5.25a19.034,19.034,0,0,1,10.492,4.35Zm-8.516.542a10.434,10.434,0,1,1-10.434,10.434A10.434,10.434,0,0,1,239.739,810Zm1.738,29.474v-5.25a13.877,13.877,0,0,0,9.237-22.308l3.714-3.714a19.106,19.106,0,0,1-12.951,31.272ZM238,801.395v5.25a13.886,13.886,0,0,0-11.9,16.5l-4.964,1.655A19.048,19.048,0,0,1,238,801.395Z",
    transform: "translate(-187.571 -782.179)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M272.379,812.6a1.739,1.739,0,0,0,1.839-.209l8.218-6.576H285.3a3.481,3.481,0,0,0,3.478-3.478V791.9a3.481,3.481,0,0,0-3.478-3.478H271.393a3.481,3.481,0,0,0-3.478,3.478v10.434a3.481,3.481,0,0,0,3.478,3.477v5.217A1.738,1.738,0,0,0,272.379,812.6Zm-.986-20.7H285.3v10.434h-3.477a1.743,1.743,0,0,0-1.086.38l-5.87,4.7v-3.337a1.736,1.736,0,0,0-1.739-1.739h-1.738V791.9Z",
    transform: "translate(-191.402 -781.471)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M196.16,805.815h2.868l8.218,6.576a1.739,1.739,0,0,0,2.826-1.358v-5.217a3.481,3.481,0,0,0,3.477-3.477V791.9a3.481,3.481,0,0,0-3.477-3.478H196.16a3.483,3.483,0,0,0-3.478,3.478v10.434A3.482,3.482,0,0,0,196.16,805.815Zm0-13.911,13.912,0v10.436h-1.739a1.738,1.738,0,0,0-1.739,1.739v3.337l-5.87-4.7a1.739,1.739,0,0,0-1.085-.38H196.16Z",
    transform: "translate(-185.726 -781.471)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M267.915,850.672a3.483,3.483,0,0,0,3.478,3.478H285.3a3.482,3.482,0,0,0,3.478-3.478V840.238a3.482,3.482,0,0,0-3.478-3.478h-2.868l-8.218-6.576a1.74,1.74,0,0,0-2.825,1.359v5.217a3.482,3.482,0,0,0-3.478,3.478v10.434Zm3.478-10.434h1.738a1.738,1.738,0,0,0,1.739-1.739v-3.337l5.87,4.7a1.744,1.744,0,0,0,1.086.38H285.3v10.434l-13.911,0Z",
    transform: "translate(-191.402 -784.592)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M192.682,850.672a3.483,3.483,0,0,0,3.478,3.478h13.912a3.482,3.482,0,0,0,3.477-3.478V840.238a3.482,3.482,0,0,0-3.477-3.478v-5.216a1.74,1.74,0,0,0-2.826-1.359l-8.218,6.576H196.16a3.483,3.483,0,0,0-3.478,3.478Zm3.478-10.434h3.478a1.739,1.739,0,0,0,1.085-.38l5.87-4.7V838.5a1.739,1.739,0,0,0,1.739,1.739h1.739v10.434H196.16Z",
    transform: "translate(-185.726 -784.592)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComunidad);
export default __webpack_public_path__ + "static/media/comunidad.1695845d2113bde5ed8d3c1b52af44cc.svg";
export { ForwardRef as ReactComponent };